// extracted by mini-css-extract-plugin
export default {"modalFooter":"BlockUser__modalFooter___U_Bqy","modalBody":"BlockUser__modalBody___FqITx","textSecondary":"BlockUser__textSecondary___wRbiv"};